module.exports = __webpack_public_path__ + "img/image_7.3f1b410b.jpg";